var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.showChatbox}},[_vm._v("\n    "+_vm._s(_vm.__('ai_chatbox', 'chat_with_our_ai'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }